import KeywordApi from '@/api/keyword'
import OpenAIConstants from '@/constant/openAI'
import TextUtils from '@/utils/textUtil'
import store from '@/vuex/store'

// state
const state = {
  keywords: [],
  applyKeyword: '',
}

// mutations
const mutations = {
  SET_KEYWORDS(state, keywords) {
    state.keywords = keywords
  },
  SET_APPLY_KEYWORD(state, keyword) {
    state.applyKeyword = keyword
  },
}

// HELPERS
const getKeywordsFromResult = (result) => {
  if (!result || !result.data || !result.data.keywords || !Array.isArray(result.data.keywords)) {
    return []
  }
  return result.data.keywords.flat()
}

const removeFirstKeywordDuplicatesAndRandomize = (keywords, desiredItemCount = 3) => {
  const keywordsWithoutFirst = keywords.slice(1)

  const uniqueKeywords = Array.from(new Set(keywordsWithoutFirst))

  const shuffledKeywords = uniqueKeywords.sort(() => Math.random() - 0.5)

  return shuffledKeywords.slice(0, desiredItemCount)
}

const getAISuggestedKeywordByPresentation = async (params) => {
  const res = await KeywordApi.getAISuggestedKeywordByPresentation(params)
  return res?.keywords || []
}

const getKeywordsByString = async (rootState, purpose, slideOption) => {
  const isPurposeQuestionImage = purpose === OpenAIConstants.AI_KEYWORD_QUESTION_IMAGE_PURPOSE
  const isPurposeSlideOptionImage = purpose === OpenAIConstants.AI_KEYWORD_SLIDE_OPTION_IMAGE_PURPOSE

  let string
  if (isPurposeQuestionImage) {
    string = store.getters.slideTitle
  }
  if (isPurposeSlideOptionImage) {
    string = store.getters['slideOptionModule/getActiveSlideOptionTitle'](slideOption)
  }

  const numberOfWordsInString = await TextUtils.countNumberOfWordsInString(string)

  let keywords
  if (numberOfWordsInString < 3) {
    keywords = [string]
  } else {
    const resultByKeywordString = await KeywordApi.getAISuggestedKeywordByString({ string })
    const resultByKeywordPresentation = await getAISuggestedKeywordByPresentation(
      { presentationId: rootState.presentation.id },
    )
    keywords = [...getKeywordsFromResult(resultByKeywordString),
      ...resultByKeywordPresentation]
  }
  return (keywords)
}

const getKeyWordsBySlideContent = async (rootState, purpose) => {
  const result = await KeywordApi.getAISuggestedKeywordByContent({
    type: OpenAIConstants.TYPE_SLIDE,
    id: rootState.slideActive.id,
    purpose,
  })

  return getKeywordsFromResult(result)
}

// actions
const actions = {
  clearKeywords({ commit }) {
    commit('SET_KEYWORDS', [])
  },
  async fetchKeywords({ commit, rootState }, params) {
    const { purpose, slideOption } = params
    if (!purpose) return []
    const types = [OpenAIConstants.AI_KEYWORD_QUESTION_IMAGE_PURPOSE,
      OpenAIConstants.AI_KEYWORD_SLIDE_OPTION_IMAGE_PURPOSE]
    const isGetByString = types.includes(purpose)

    let keywords

    if (isGetByString) {
      keywords = await getKeywordsByString(rootState, purpose, slideOption)
    } else {
      const resultBySlideContent = await getKeyWordsBySlideContent(rootState, purpose)
      const resultByKeywordPresentation = await getAISuggestedKeywordByPresentation(
        { presentationId: rootState.presentation.id },
      )
      keywords = [...(resultBySlideContent),
        ...getKeywordsFromResult(resultByKeywordPresentation)]
    }

    commit('SET_KEYWORDS', removeFirstKeywordDuplicatesAndRandomize(keywords))
    return keywords || []
  },
  setApplyKeyword({ commit }, keyword) {
    commit('SET_APPLY_KEYWORD', keyword)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
